<div class="wizard-inner-container full">
  <div class="wizard-registration-title margin-bottom-32">
    <div>{{ "onboarding.titles.service_types" | translate }}</div><span class="help fa hubtiger-tooltip" pTooltip="{{ 'onboarding.messages.service_types_info' | translate}}"></span>
  </div>
  <div class="wizard-form">
    <app-shared-service-types
      *ngIf="!loading"
      [partnerID]="partner.ID"
      [currencySymbol]="partner.CurrencySymbol"
      [Categories]="CATEGORIES"
      [isPortal]="isPortal"
      [messageService]="messageService"
      [vatInclusive]="partner.VATInclusive"
    ></app-shared-service-types>
    <div>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <button
            (click)="skipToHubtiger()"
            class="iso-round-button iso-secondary w-100">{{ 'onboarding.button.take_me_to_hubtiger' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
